import React from 'react';
import PropTypes from 'prop-types'
function FormAndCalloutBox({
  children
}) {
  return (
    <div className="mz-form-and-callout-box">
      <div className="mz-container">
        <div className="mz-full-width grid-inner-2-10-md grid-inner-2-10-lg mz-form-and-callout-box__inner">
          {children}
        </div>
      </div>
    </div>
  )
}

FormAndCalloutBox.Form = ({ children }) => <div className="mz-form-and-callout-box__form">{children}</div>
FormAndCalloutBox.Callout = ({ children }) => <div className="mz-form-and-callout-box__callout">{children}</div>

FormAndCalloutBox.propTypes = {
  children: PropTypes.array.isRequired,
}

export default FormAndCalloutBox